import { createAction } from '@ngrx/store';
export const reset = createAction('[-] Reset state');
